import { createContext } from 'react';
import { MyVenue } from '../../../../@api-client';

export interface VenueContextType {
  activeVenue: MyVenue;
  applicationVenues: MyVenue[];
  changeVenue: (targetVenueSlug: string) => Promise<void>;
  allVenues: MyVenue[];
  /** Whether these grants have been confirmed since the session mounted (FR-058). */
  isAuthorityResolved: boolean;
}

export const VenueContext = createContext<VenueContextType | undefined>(undefined);
